// Desktop hover-to-open for mega-menu. Click/keyboard fallback untouched.
// Why: keeps <details> accessibility + touch behavior, adds pointer affordance.
(function () {
  const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!hoverCapable.matches) return;

  const CLOSE_DELAY = 150;

  function init() {
    document.querySelectorAll('header-menu').forEach((headerMenu) => {
      const details = headerMenu.querySelector('details');
      if (!details || headerMenu.dataset.hoverBound) return;
      headerMenu.dataset.hoverBound = 'true';

      let closeTimer = null;

      const open = () => {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        if (details.hasAttribute('open')) return;
        document.querySelectorAll('header-menu details[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
        details.setAttribute('open', '');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      };

      const scheduleClose = () => {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (!details.hasAttribute('open')) return;
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      };

      headerMenu.addEventListener('mouseenter', open);
      headerMenu.addEventListener('mouseleave', scheduleClose);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
